<h1 mat-dialog-title>Ga naar vraag</h1>

<mat-dialog-content>
  <form class="flex flex-col gap-4">
    <div class="space-y-2">
      <div class="font-medium text-sm">Vraag</div>
      <mat-form-field class="w-full">
        <mat-select placeholder="Selecteer een vraag" [formControl]="control">
          @for (question of questions; track $index) {
            <mat-option [value]="question">{{ question.value }}</mat-option>
          }
        </mat-select>
        <mat-error>Veld is verplicht</mat-error>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close [disabled]="submitted()">Annuleren</button>

  <button
    mat-button
    (click)="handleConfirm()"
    [disabled]="submitted() || control.invalid || !questions.length"
  >
    <mat-spinner
      class="!absolute inset-0 m-auto pointer-events-none transition-opacity ease-in-out"
      [diameter]="16"
      [class.opacity-100]="loading()"
      [class.opacity-0]="!loading()"
    ></mat-spinner>

    <span [class.opacity-0]="loading()" class="transition-opacity">Opslaan</span>
  </button>
</mat-dialog-actions>
